/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CashflowForecastIndicatorConnection', 'model/CashflowForecastIndicatorConnectionReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CashflowForecastIndicatorConnection'), require('../model/CashflowForecastIndicatorConnectionReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CashflowForecastIndicatorConnectionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CashflowForecastIndicatorConnection, root.ForStractionServiceApi.CashflowForecastIndicatorConnectionReport);
  }
}(this, function(ApiClient, CashflowForecastIndicatorConnection, CashflowForecastIndicatorConnectionReport) {
  'use strict';

  /**
   * CashflowForecastIndicatorConnection service.
   * @module api/CashflowForecastIndicatorConnectionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CashflowForecastIndicatorConnectionApi. 
   * @alias module:api/CashflowForecastIndicatorConnectionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the cashflowForecastIndicatorConnectionAddPut operation.
     * @callback module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastIndicatorConnection} body 
     * @param {module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.cashflowForecastIndicatorConnectionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorConnectionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorConnectionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorConnection/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorConnectionDeleteGet operation.
     * @callback module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorID 
     * @param {module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorConnectionDeleteGet = function(_4SAPIAppID, indicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorConnectionDeleteGet";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling cashflowForecastIndicatorConnectionDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorConnection/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorConnectionEditPut operation.
     * @callback module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastIndicatorConnection} body 
     * @param {module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorConnectionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorConnectionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorConnectionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorConnection/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorConnectionLoadAllGet operation.
     * @callback module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CashflowForecastIndicatorConnectionReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/CashflowForecastIndicatorConnectionApi~cashflowForecastIndicatorConnectionLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CashflowForecastIndicatorConnectionReport>}
     */
    this.cashflowForecastIndicatorConnectionLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorConnectionLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [CashflowForecastIndicatorConnectionReport];

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorConnection/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
